export default __webpack_public_path__ + "static/media/illustrator.022d38c5.png";